import styled from 'styled-components/macro'

import { colors } from 'constants/colors'

export const PolicyTextLink = styled.a`
  color: ${colors.gray950};
  font-weight: 600;
`
